import $ from "jquery";

$(() => {
    const elements: NodeListOf<Element> = document.querySelectorAll('.teaser-block');

    if (elements.length > 0) {
        elements.forEach((el: Element) => {
            // Hela puffblocket ska bete sig som en länk:
            // a-taggen ligger inuti blocket istället för att wrappa puffblocket för att skrämläsare ska kunna läsa upp länk och innehåll i blocket. Samtidigt kan man snabbt navigera mellan länkar på andra puffblock.
            el.addEventListener('click', (event: MouseEvent) => {
                const aElem: HTMLAnchorElement = (el as HTMLElement).querySelector("a.ignore-link-focus");
                if (aElem != null) {
                    event.preventDefault();
                    // När man klickar på blocket går vi till samma sida som a-taggen inuti blocket länkar till    
                    if (event.ctrlKey || event.metaKey) {
                        window.open(aElem.href, '_blank')
                    }
                    else {

                        window.location.href = aElem.href;
                    }
                }
            });
        })
    }

});

